import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from './PlanModal.module.scss';
import PlanPanel from '../PlanPanel';
import useActivePlan from 'utils/useActivePlan';
import { settingsActions } from 'Containers/Settings/store';
import { getActiveSalon } from 'Containers/Auth/store/selectors';
import { getCustomerProducts, getProductsLoading } from 'Containers/Settings/store/selectors';
import { goToBilling, goToPremiumUpgrade } from 'utils/premiumUpgradePath';

const selectProducts = getCustomerProducts();
const selectProductsLoading = getProductsLoading();

const PlanModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeSalon = useSelector(getActiveSalon());
  const products = useSelector(selectProducts);
  const productsLoading = useSelector(selectProductsLoading);
  const plan = useActivePlan();

  useEffect(() => {
    const hasProducts = Boolean(products && Object.keys(products).length);
    if (hasProducts || productsLoading) return;
    dispatch(settingsActions.GET_CUSTOMER_PRODUCTS.REQUEST({}, null, { skipLoader: true }));
  }, [dispatch, products, productsLoading]);

  const handleUpgradeClick = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    // Chiudi il modal solo dopo la navigate (anti ghost-tap su Fatturazione in WebView).
    goToPremiumUpgrade(navigate, {
      onAfterNavigate: () => closeModal?.(),
    });
  };

  const handleManageClick = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    goToBilling(navigate, {
      onAfterNavigate: () => closeModal?.(),
    });
  };

  return (
    <div className={styles.plan_modal_container}>
      <PlanPanel
        plan={plan}
        salon={activeSalon}
        showCloseButton
        onClose={closeModal}
        onUpgradeClick={handleUpgradeClick}
        onManageClick={handleManageClick}
      />
    </div>
  );
};

export default PlanModal;
